/* VTM Cart Milestones - live free-shipping / gift progress (Vikas Tool Mart) */
(function () {
  if (window.__vtmMilestones) return;
  window.__vtmMilestones = true;

  var SECTION_ID = null;
  function sectionId() {
    if (SECTION_ID) return SECTION_ID;
    var el = document.querySelector('[id^="shopify-section-"][id$="__vtm-milestones"]');
    if (el) SECTION_ID = el.id.replace('shopify-section-', '');
    return SECTION_ID;
  }
  var html = null;
  var timer = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function extract(markup) {
    var d = document.createElement('div');
    d.innerHTML = markup;
    var src = d.querySelector('[data-vtm-ms-source]');
    return src ? src.innerHTML.trim() : '';
  }

  function ensureSlots() {
    var anchors = document.querySelectorAll('[data-cart-subtotal], .totals__subtotal');
    anchors.forEach(function (a) {
      var box = a.classList.contains('totals__subtotal') ? a.parentElement : a;
      if (!box) return;
      var n = box.nextElementSibling;
      if (n && n.hasAttribute('data-vtm-milestones')) return;
      var slot = document.createElement('div');
      slot.setAttribute('data-vtm-milestones', '');
      slot.hidden = true;
      box.insertAdjacentElement('afterend', slot);
    });
  }

  function paint() {
    if (html === null) return;
    ensureSlots();
    document.querySelectorAll('[data-vtm-milestones]').forEach(function (slot) {
      if (slot.getAttribute('data-vtm-painted') === html) return;
      slot.innerHTML = html;
      slot.setAttribute('data-vtm-painted', html);
      slot.hidden = html === '';
    });
  }

  function refresh() {
    if (!sectionId()) return;
    fetch(root + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || typeof j[SECTION_ID] !== 'string') return;
        html = extract(j[SECTION_ID]);
        paint();
      })
      .catch(function () {});
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(refresh, delay || 250);
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js|\.json)?/.test(String(url || ''));
  }

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = origFetch.apply(this, arguments);
      if (isCartMutation(url)) p.then(function () { schedule(); }, function () {});
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) this.addEventListener('loadend', function () { schedule(); });
    return origOpen.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart-update', 'ajaxProduct:added'].forEach(function (ev) {
    document.addEventListener(ev, function () { schedule(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(0); });

  var raf = 0;
  new MutationObserver(function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; paint(); }); }).observe(document.documentElement, { childList: true, subtree: true });

  function init() {
    var onPage = document.querySelector('[data-vtm-ms-source]');
    if (onPage) { html = onPage.innerHTML.trim(); paint(); }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
